// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5xzYm","modal":"styles_modal__NDF+3","modalMain":"styles_modalMain__LU2oi","modalFooter":"styles_modalFooter__sYn4U"};